import { defineMessages } from 'react-intl'

export default defineMessages({
    accentTitle: {
        id: 'containers.SupplierPage.Profile.Accents.accentTitle',
        defaultMessage: 'Accents',
    },
    accentDescription: {
        id: 'containers.SupplierPage.Profile.Accents.accentDescription',
        defaultMessage: 'A distinctive way of pronouncing words, influenced by regional or cultural factors.',
    },
    accentSelectPlaceholder: {
        id: 'containers.SupplierPage.Profile.Accents.accentSelectPlaceholder',
        defaultMessage: 'Select Accents',
    },
    dialectTitle: {
        id: 'containers.SupplierPage.Profile.Dialects.dialectTitle',
        defaultMessage: 'Dialects',
    },
    dialectDescription: {
        id: 'containers.SupplierPage.Profile.Dialects.dialectDescription',
        defaultMessage: 'A variation of a language with differences in pronunciation, vocabulary, and grammar, often associated with a specific region or community.',
    },
    dialectSelectPlaceholder: {
        id: 'containers.SupplierPage.Profile.Dialects.dialectSelectPlaceholder',
        defaultMessage: 'Select Dialects',
    }
})
